<template>
  <div class="dCC p14 improveData">
    <div class="pr w100b">
      <p class="f20 fb tc mb20">请完善贸易背景信息 </p>
      <div class="w150 tips fcenter jcc">
        <i class="question mr10"></i><span> 不知道如何上传?</span>
        <div class="tips-show tl">
          <div>
            <p class="f14 c333 tl fb">合同</p>
            <p class="">①主合同要完整，不能取其中几页上传；</p>
            <p>②填写的合同编号和金额与上传合同上的要一致；合同号大小写也要一致；</p>
            <p>③合同中无金额需在其他资料中上传结算单或者入库单（结算单需盖章），合同金额填写该笔对应的票据结算单金额</p>
            <p>④多个合同填文件中第一个合同编号；</p>
            <p>⑤合同若无编号，手写一个编号；合同编号得用签字笔写</p>
            <p>⑥合同中明确本合同签字盖章生效需既有签字和公章</p>
            <p>⑦合同章要清晰可见，扫描件或复印件要盖鲜章；</p>
            <p>⑧合同日期需早于发票日期</p>
            <p>⑨合同文件大小在20M内；合同过大的，请上传全部主合同，可不带附件，超过100页，另行沟通。</p>
          </div>
          <div class="mt20">
            <p class="f14 c333 tl fb">发票</p>
            <p>①拍照或截图上传，不支持pdf；发票若为复印件需加盖融资人鲜章</p>
            <p>②发票章清晰；③发票明细与合同中一致；</p>
            <p>④票面金额≤发票金额≤合同金额</p>
            <p>⑤发票需要补充销货清单</p>
          </div>
          <div class="fJCenter pt20 ">
            <Button type="primary" class="w268" @click="handleCustomerBtn()">请客服协助我上传</Button>
          </div>
        </div>
      </div>
    </div>


    <div class="bgFAFAFA w100b mt20 p14 h362 fStart">
      <div class="h334 w220 br4 bgfff pt10 mr20">
        <div class="title bbccc fSpace pb10 c333 pl14 pr14"><span>贸易合同</span><span :class="[code3Param.contract.filename?'':'cB50000']">{{code3Param.contract.filename?'已上传':'未上传'}}</span></div>

        <div class="dCC h275">
          <div class="agreement_bg">
            <div class="agreement-top">
              <div class="agreement">
                <div class="agreement_upload " v-if="code3Param.contract.filename"></div>
                <div v-else class="no_agreement_upload cp" @click="imgUploadClick('agreement_upload','agreement')"></div>
                <imgUpload v-show="!code3Param.contract.filename" ref="agreement_upload" :params="imgUploadParams" @change="agreementUploadChange" :width="'42px'" :height="'48px'" :format="['word','pdf']" class="no_agreement_upload dn">
                </imgUpload>
              </div>
            </div>
            <div>
              <div class="h40 f12">
                <p>{{code3Param.contract.filename?code3Param.contract.filename.length > 20? code3Param.contract.filename.slice(0,14)+'...' + code3Param.contract.filename.split('.')[0].slice(-3)+ '.'+code3Param.contract.filename.split('.')[1] :code3Param.contract.filename: '贸易合同文件'}}</p>
                <p v-if="!code3Param.contract.filename">.pdf/PDF格式</p>
              </div>
              <div>
                <Button class="agreement_upload_btn " @click="imgUploadClick('agreement_upload','agreement')">
                  <svg-icon class="mr5 f14" icon-class="upload" v-if="!code3Param.contract.filename "></svg-icon> {{code3Param.contract.filename?'重新上传':'上传'}}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h334 w640 br4 bgfff pt10 mr20">
        <div class="title bbccc fSpace pb10 c333 pl14 pr14">
          <span>发票</span><span v-if="invoiceCount>0" class="">已上传 <span class=" fb">{{`${invoiceCount}`}}</span> 张</span><span class=" cB50000" v-else>至少上传<span class="fb"> 1 </span>张发票</span>
        </div>
        <div class="fStart invoice_bg">
          <div v-for="(item,index) in code3Param.invoice" :key="index" class="h275 df aic ">
            <div class="dCC invoice-item">

              <div class="invoice_upload">
                <img :src="item.fileUrl" alt="" v-if="item.fileUrl">
                <div v-else class="imgUploadBg" @click="imgUploadClick(`imgUpload${index}`,'img',index)"></div>
                <imgUpload :params="imgUploadParams" :ref="`imgUpload${index}`" @change="imgUploadChange" :width="'42px'" :height="'48px'" v-show="!item.fileUrl" :format="['png','jpg']" class="imgUploadBg dn" />
              </div>

              <div class="h40 f12 mt10">
                <p class="c000">{{item.fileUrl?'发票': '发票图片'}} {{index+1}}</p>
                <p v-if="!item.fileUrl" class="c666">截图/清晰的照片</p>
              </div>
              <div class="fStart aic  ">
                <Button class="agreement_upload_btn" @click="imgUploadClick(`imgUpload${index}`,'img',index)">
                  <svg-icon class="mr5 f14" icon-class="upload" v-if="!item.fileUrl"></svg-icon>{{item.fileUrl ? '重新上传': '上传'}}
                </Button>
                <Button @click="invoiceDel(index)" class="delete_invoice ml10"><span class="delete_btn"></span></Button>
              </div>
            </div>
          </div>

          <div class="dCC h275 w123 invoiceAdd_bg">
            <div>
              <div class="invoiceAdd_inner cp" @click="invoiceAdd">
                <div class="invoiceAdd"></div>
              </div>
              <div class="h40 f12 mt10">
                <p>追加发票</p>
              </div>
              <Button class="invoice_btn " @click="invoiceAdd">
                + 追加
              </Button>
            </div>

          </div>
        </div>
      </div>
      <div class="h334 w260 br4 bgfff pt10 ">
        <div class="title bbccc fSpace pb10 c333 pl14 pr14"><span>其他</span><span :class="[code3Param.other.filename?'':'cB50000']">{{code3Param.other.filename?'已上传':'未上传'}}</span></div>
        <div class="dCC h275">
          <div class="agreement_bg">
            <div class="agreement-top">
              <div class="agreement">
                <div v-if="code3Param.other.filename" :class="fileType"></div>
                <div v-else class="no_agreement_upload cp" @click="imgUploadClick('other_upload','other')"></div>
                <imgUpload ref="other_upload" :params="imgUploadParams" @change="otherUploadChange" :width="'42px'" :height="'48px'" class="no_agreement_upload dn" :format="[]">
                </imgUpload>
              </div>
            </div>
            <div>
              <div class="h40 f12 mt10">
                <p v-if="code3Param.other.filename">{{code3Param.other.filename ?code3Param.other.filename.length > 20? code3Param.other.filename.slice(0,14)+'...' +code3Param.other.filename.split('.')[0].slice(-3) + '.'+code3Param.other.filename.split('.')[1] :code3Param.other.filename : ''}}</p>
              </div>
              <div>
                <Button class="agreement_upload_btn " @click="imgUploadClick('other_upload','other')">
                  <svg-icon class="mr5 f14" icon-class="upload" v-if="!code3Param.other.filename"></svg-icon>{{code3Param.other.filename?'重新上传':'上传'}}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tc mt20">
      <Button type="primary" class="mr20 w200" :disabled="disabled" @click="submit"> 提交</Button>
      <Button type="default" class="w152 bgfff" @click="parentsData.orderCancelShow = true">取消订单</Button>
    </div>
  </div>
</template>

<script>
import imgUpload from '@/components/module/imgUpload'

export default {
  inject: ['parentsData'],
  components: {
    imgUpload
  },
  data () {
    return {
      code3Param: {

        contract: { filename: '', fileUrl: '', loading: false }, // 合同

        invoice: [{ filename: '', fileUrl: '', loading: false }], // 发票列表

        other: { filename: '', fileUrl: '', loading: false }// 其他文件
      },
      imgUploadParams: {
        ocr: false,
        loadding: false,// 上传中 Loading 效果
        isShowImg: true,// 图片预览
        isReUpload: false, // 是否展示重新上传按钮
        // ocr: { // ocr 识别
        //   picType: ''// 上传图片类型 用于OCR识别
        // },
      },
      // disabled: false,
      imgIndex: 0,// 当前发票列表操作索引
    }
  },
  computed: {

    invoiceCount () {
      let count = 0
      this.code3Param.invoice.map(item => {
        if (item.fileUrl) {
          count++
        }
      })
      return count
    },
    disabled () {
      let code3Param = this.code3Param
      return code3Param.contract.fileUrl && code3Param.invoice.some(item => item.fileUrl) ? false : true
    },
    fileType () {
      let type = this.code3Param.other.filename ? this.code3Param.other.filename.split('.')[1] : ''
      let style = ''
      console.log(type);
      switch (type) {
        case 'pdf':
          style = 'agreement_upload'
          break;
        case 'word':
          style = 'agreement_upload_word'
          break;
        case 'doc':
          style = 'agreement_upload_word'
          break;
        case 'excel':
          style = 'agreement_upload_excel'
          break;
        default:
          style = 'agreement_upload_file'
          break;
      }
      return style
    }
  },
  created () { },
  methods: {

    imgUploadClick (e, type, index) {
      console.log(e, index, this.imgIndex, this.$refs[e]);
      switch (type) {
        case 'agreement':
          this.$refs[e].reUpload()
          break;
        case 'img':
          this.$refs[e][0].reUpload()
          this.imgIndex = index
          break;
        case 'other':
          this.$refs[e].reUpload()
          break;
      }


      if (index) {
        this.imgIndex = index
      }

      console.log(e, index, this.imgIndex);
    },
    // 合同上传
    agreementUploadChange (name, url,) {
      // console.log(name, emeit);
      this.code3Param.contract.filename = name
      this.code3Param.contract.fileUrl = url
      this.$set(this.code3Param.contract, 'filename', name)
      this.$set(this.code3Param.contract, 'fileUrl', url)
    },
    // 图片上传
    imgUploadChange (emeit) {
      console.log(emeit, this.imgIndex);
      // this.code3Param.invoice[this.imgIndex].fileUrl = emeit.url
      this.$set(this.code3Param.invoice[this.imgIndex], 'fileUrl', emeit.url)
      console.log(emeit, this.imgIndex, this.code3Param.invoice[this.imgIndex]);
    },
    // 其他文件上传
    otherUploadChange (name, url, fieldName) {
      console.log(name, url, fieldName);
      if (Object.prototype.toString.call(name) === '[object Object]') {
        this.$set(this.code3Param.other, 'filename', fieldName)
        this.$set(this.code3Param.other, 'fileUrl', name.url)
      } else {
        this.$set(this.code3Param.other, 'filename', name)
        this.$set(this.code3Param.other, 'fileUrl', url)
      }
      console.log(this.disabled);
    },
    invoiceAdd () {
      this.code3Param.invoice.push({ filename: '', file: '', fileUrl: '', loading: false })
    },
    // invoiceAdd
    invoiceDel (index) {
      this.code3Param.invoice[index].fileUrl = ''
      this.code3Param.invoice[index].filename = ''
      if (this.code3Param.invoice.length > 1) {
        this.code3Param.invoice.splice(index, 1)
      }
    },

    submit () {
      let arr = []
      let code3Param = this.code3Param
      this.code3Param.invoice.map(item => {
        if (item.fileUrl) {
          arr.push(item.fileUrl)
        }
      })
      let params = {
        orderJd: {
          contractFile: code3Param.contract.fileUrl, //合同文件
          contractNo: '', //合同编号
          contractAmount: '', //合同金额（元）
          invoiceFileList: arr, //发票文件列表
          otherFile: code3Param.other.fileUrl //其他文件
        } //京东订单附属信息
      }
      console.log('parentsData', this.parentsData);
      // /cp-discount-order/submit-data/{{CPOrderId}}
      this.sendOther({
        url: `/trade-center/cp-discount-order/submit-data/${this.parentsData.allParam.id}`,
        data: params
      }, (result) => {
        console.log(result);
        this.parentsData.getDetail(this.parentsData.allParam.id)
      })

    }

  }
}
</script>
<style lang="less" scoped>
.bgECF1FF {
  background-color: #ecf1ff;
}
.ivu-btn-primary[disabled] {
  background-color: #f3271d8f !important;
  color: #fff;
  border: none !important;
}
/deep/.ivu-btn-primary:hover {
  opacity: 0.7;
  color: #fff;
}
.bgfff {
  background-color: #fff !important;
}

.improveData {
  .tips {
    padding: 2px 6px;
    border-radius: 4px;
    width: 150px;
    height: 30px;
    top: 10px;
    position: absolute;
    top: 0;
    right: 20px;
    cursor: pointer;
    color: #333;
    text-align: center;
    box-shadow: 0px 2px 5px 0px rgba(194, 194, 194, 0.5);
    &:hover {
      .tips-show {
        display: block;
      }
    }
    .question {
      display: inline-block;
      width: 11px;
      height: 13px;
      background: url(~@/assets/img/businessTicketDiscount/icon_wenti.png);
    }
    .tips-show {
      display: none;
      width: 600px;
      height: 400px;
      position: absolute;
      top: 0;
      right: 100%;
      background: #fff;
      color: #333333;
      font-size: 12px;
      padding: 17px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
      border-radius: 6px 6px 6px 6px;
      z-index: 99;
      &::before {
        width: 0;
        height: 0;
        border: 6px solid #fff;
        content: '';
        border-right-color: transparent;
        border-top-color: transparent;
        border-bottom-color: transparent;
        border-left: 8px solid #fff;
        position: absolute;
        top: 10px;
        right: -14px;
      }
    }
  }
  .agreement_bg {
    width: 124px;
    height: 201px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: wrap;
    // background: #ecf1ff;
    .agreement-top {
      width: 100%;
      height: 105px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .no_agreement_upload {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/wenjian_sc_a.png)
      no-repeat center center;
  }
  .agreement_upload {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/PDF.png) no-repeat
      center center;
  }
  .agreement_upload_word {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/word.png) no-repeat
      center center;
  }
  .agreement_upload_excel {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/Excel.png) no-repeat
      center center;
  }
  .agreement_upload_file {
    width: 42px;
    height: 48px;
    background: url(~@/assets/img/businessTicketDiscount/tongyong.png) no-repeat
      center center;
  }
  .invoice_bg {
    width: 100%;
    overflow-x: auto;
    .agreement {
      width: 124px;
      height: 201px;
    }
    .invoice-item {
      width: 124px;
      height: 201px;
      margin: 0 19px;
      .invoice_upload {
        width: 105px;
        height: 105px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100%;
        }
      }
    }

    .invoiceAdd_bg {
      width: 124px;
      height: 201px;
      margin-right: 20px;
      .invoiceAdd_inner {
        width: 105px;
        height: 105px;
        display: flex;
        justify-content: center;
        align-items: center;
        .invoiceAdd {
          width: 42px;
          height: 48px;
          background: url(~@/assets/img/businessTicketDiscount/wenjian_zhuijia.png)
            no-repeat center center;
          background-size: contain;
        }
      }
    }

    .invoice_btn {
      display: inline-block;
      // width: 60px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid #cbcbcb;
      cursor: pointer;
      background: #fff;
      color: #333;
    }
    .invoice_btn:hover {
      border: 1px solid #e9e9e9;
    }
    .delete_invoice {
      width: 30px;
      height: 30px;
      display: inline-block;
      background: #fff;
      border-radius: 4px;
      border: 1px solid #cbcbcb;
      display: flex;
      justify-content: center;
      .delete_btn {
        display: inline-block;
        width: 12px;
        height: 14px;
        background: url(~@/assets/img/businessTicketDiscount/icon_shanchu.png)
          no-repeat center center;
      }
    }
    .delete_invoice:hover {
      border: 1px solid #e9e9e9;
    }

    .imgUploadBg {
      width: 42px;
      height: 48px;
      background: url(~@/assets/img/businessTicketDiscount/wenjian_sc_b.png)
        no-repeat center center;
      cursor: pointer;
      background-size: contain;
    }
  }

  .agreement_upload_btn {
    display: inline-block;
    height: 30px;
    min-width: 66px;
    line-height: 30px;
    border-radius: 4px;
    padding: 0 6px;
    border: 1px solid #cbcbcb;
    cursor: pointer;
    background: #fff;
    color: #333;
  }
  .agreement_upload_btn:hover {
    border: 1px solid #e9e9e9;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessTicketDiscount/component/improveDataJdMR.vue